import analyticDataStore, {
  IBaseAnalyticsCombined,
} from "@/store/analyticsDataStore";
import { addNewAnalticToStore } from "@/store/analyticsDataStoreACTIONS";
import "ag-charts-enterprise";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import DateRangeAndSlider from "./DateRangeAndSlider";
import MapChart from "./MapChart";
import SecurityTypesPieChart from "./SecurityTypesPieChart";
import TradesPastSevenDays from "./TradesPastSevenDays";

export interface IClientSummaryFilters {
  range: number[];
  selectedInstruments: string[];
  countryActive: string;
  activeDay: Date | undefined;
}

export const baseFilterClientSummary = {
  range: [],
  selectedInstruments: [],
  countryActive: "",
  activeDay: undefined,
};

const IndexClientSummary = () => {
  const analyticsZustand = analyticDataStore((state) => state.analyticData);

  const [data, setData] = useState<IBaseAnalyticsCombined[]>(analyticsZustand);

  useEffect(() => {
    setData(analyticsZustand);
  }, [analyticsZustand]);

  const [dataFilters, setDataFilters] = useState<IClientSummaryFilters>(
    baseFilterClientSummary,
  );

  const isSecondary = dataFilters.activeDay ? true : false;

  const { theme } = useTheme();

  function addLast7() {
    addNewAnalticToStore(); // Call Zustand and add a new (recent item)
  }

  return (
    <div data-testid="ClientSummaryIndex" className="w-fill h-full p-1">
      <button
        onClick={() => addLast7()}
        className="absolute bottom-10 right-10 z-10 rounded-xl bg-gray-300 p-2 dark:bg-gray-700"
      >
        +
      </button>

      <div className="flex h-full w-full gap-3">
        <div className="flex h-full min-w-[230px] flex-col gap-3">
          {/* TOP SQUARE */}
          <div
            className={`${theme == "dark" ? "agChartCubeBorderDark" : "agChartCubeBorder"} h-[550px] w-full p-2`}
          >
            <div className="h-full w-full">
              <div className="w-full">
                <DateRangeAndSlider
                  dataFilters={dataFilters}
                  setDataFilters={setDataFilters}
                  isSecondary={isSecondary}
                />
              </div>
              <div className="flex h-full justify-center">
                <SecurityTypesPieChart
                  data={data}
                  dataFilters={dataFilters}
                  setDataFilters={setDataFilters}
                />
              </div>
            </div>
          </div>
          {/* BOTTOM SQUARE */}
          <div
            className={`${theme == "dark" ? "agChartCubeBorderDark" : "agChartCubeBorder"} ${dataFilters.activeDay ? "!border-blue-100 dark:!border-slate-600" : ""} h-full overflow-hidden p-2`}
          >
            <TradesPastSevenDays
              data={data}
              dataFilters={dataFilters}
              setDataFilters={setDataFilters}
            />
          </div>
        </div>
        {/* Responsive section of widget frame - will expand and contract as requierd. */}
        {dataFilters.range.length > 0 && (
          <MapChart
            data={data}
            dataFilters={dataFilters}
            setDataFilters={setDataFilters}
          />
        )}
      </div>
    </div>
  );
};

export default IndexClientSummary;
